import { HTTPError } from 'ky';
import { IApiResponseError } from '@api/types';

type GeneralError = string;
interface FormError {
    name: string;
    errors: string[];
}

interface ErrorMessages {
    // Название формы
    [formName: string]: {
        fields: {
            [fieldName: string]: {
                [errorCode: number]: string; // Сообщения об ошибках для конкретных полей
                default?: string; // Дефолтное сообщение для поля
            };
        };
        [errorCode: number]: string; // Сообщения для ошибок, не связанных с полями (общие)
        default: string; // Дефолтное сообщение для формы
    };
}
/**
 *  Обрабатывает ошибки от бекенда и возвращает их для использования в форме и общих уведомления
 */
const handleErrorResponse = async (
    error: HTTPError,
    errorMessages: ErrorMessages,
    t: (key: string) => string,
    formName: string,
): Promise<{ formErrors: FormError[]; generalErrors: GeneralError[] }> => {
    const formErrors: FormError[] = [];
    const generalErrors: GeneralError[] = [];

    try {
        // Проверяем, что ошибка является HTTPError и что форма присутствует в словаре ошибок
        if (error?.name === 'HTTPError' && errorMessages[formName]) {
            const response: IApiResponseError = await error.response.json();
            if (response?.errors?.length > 0) {
                response.errors.forEach(item => {
                    const { error_field, error: errorCode } = item;
                    if (error_field) {
                        const fieldMessages = errorMessages[formName].fields[error_field];
                        // Если есть ошибки для этого поля, ищем сообщение по коду ошибки
                        if (fieldMessages) {
                            const messageText = fieldMessages[errorCode] || fieldMessages.default;
                            formErrors.push({
                                name: error_field,
                                errors: [t(messageText)],
                            });
                        } else {
                            // Если ошибок для поля нет, используем общую ошибку формы
                            generalErrors.push(t(errorMessages[formName].default));
                        }
                    } else {
                        // Если нет error_code, выводим общую ошибку формы
                        // eslint-disable-next-line no-lonely-if
                        if (errorMessages[formName][errorCode]) {
                            generalErrors.push(t(errorMessages[formName][errorCode]));
                        } else {
                            generalErrors.push(t(errorMessages[formName].default));
                        }
                    }
                });
            } else {
                // Если статус не 422, добавляем стандартное сообщение об ошибке
                generalErrors.push(t('SOMETHING_WENT_WRONG'));
            }
        } else {
            // Если форма не найдена в словаре ошибок
            generalErrors.push(t('SOMETHING_WENT_WRONG'));
        }
    } catch (tryCatchError) {
        // Логируем ошибку для отладки
        console.error('Ошибка при обработке ответа от бэкенда:', tryCatchError, error, formName);
        generalErrors.push(t('ERROR_PROCESSING_RESPONSE'));
    }

    return { formErrors, generalErrors };
};

export default handleErrorResponse;
